
export default {
  props: {},
  inject: {
    rtXpcStickyContainer: {
      default: undefined
    },
    rtXpcStickyItems: {
      default: undefined
    }
  },
  data () {
    return {
    }
  },

  mounted () {

  },

  beforeDestroy () {
  },
  methods: {}
}



// WEBPACK FOOTER //
// ./~/vue-xpc/src/mixins/sticky/stickyItem.js